import { LinkTracking } from '../context/tracking';
import { track } from '../track/track';

interface Payload extends LinkTracking {
  id: string;
  name?: string;
  onTrack?: () => void;
}

/**
 * @once
 */
export const trackServiceCard = ({ id, name, linkType, linkHref, onTrack }: Payload): void => {
  track('event.ServiceCard', { id, name, linkType, linkHref }, { callback: onTrack, once: false });
};
